import React, { useState } from 'react';
import { Stack, Button } from '@mui/material';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import Uploader from './Uploader';

export default function Gallery({ id, title = 'تصاویر', media = [], refetch }) {
  const [open, setOpen] = useState(false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const mobile = media.find((x) => x.collection_name === 'mobile');
  const desktop = media.find((x) => x.collection_name === 'desktop');

  return (
    <>
      <Button size="medium" color="warning" variant="outlined" onClick={onOpen}>
        {title}
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <Uploader
              id={id}
              media={desktop}
              refetch={refetch}
              model="Module"
              collection="desktop"
              label="تصویر سایز دسکتاپ"
              caption="1920 * 400"
            />
            <Uploader
              id={id}
              media={mobile}
              refetch={refetch}
              model="Module"
              collection="mobile"
              label="تصویر سایز موبایل"
              caption="400 * 200"
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions></NewDialogActions>
      </NewDialog>
    </>
  );
}
